<template>
    <form action="/" >
        <van-search
            class="wrapper__header__search"
            :style="{padding: '5px'}"
            v-model="inputValue"
            shape="round"
            :clearable="false"
            placeholder="请输入搜索关键词"
            @search="onSearch"
        />
    </form>
</template>
<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
// import { Toast } from 'vant'
export default {
  name: 'SearchNews',
  props: {
    newspaper: String
  },
  setup (props) {
    // const onSearch = (val) => Toast(val)
    const inputValue = ref()
    const router = useRouter()
    const store = useStore()
    const onSearch = (val) => {
      store.dispatch('searchInputValue', val)
      router.push('/search')
    }
    return {
      inputValue,
      onSearch
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
